import { render } from "./BookingsActiveIcon.vue?vue&type=template&id=7067d9ea"
import script from "./BookingsActiveIcon.vue?vue&type=script&lang=js"
export * from "./BookingsActiveIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__